import React, { Component } from 'react';
import './style.css';
import '../../../../../../../index.css';
class IntelligentInlineHeader extends Component {
  render() {
    const {handleVisible}=this.props;
    return (
      <div className="intelligentInlineHeader_box">
        <img alt="" onClick={()=>handleVisible(-1)} src={require('../../../../../../../images/intelligent/close.png')}></img>
      </div>
    );
  }
}

export default IntelligentInlineHeader;


// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentInlineMajorModal/components/IntelligentInlineHeader/index.js